




















































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import widgetCommon from './widgetCommon'
import widgetPop from './widgetPop'
@Component({
  components: {
  }
})
export default class extends Mixins(widgetCommon, widgetPop) {
  private get currentRadio () {
    let current = this.form[this.item.businessId]
    if (current) {
      return this.item.options.find(({key}) => key === current)
    }
    return ''
  }
  private popupValue = null
  public initField () {
    if (this.isUndef(this.form[this.item.businessId])) {
      this.form[this.item.businessId] = this.item.defaultValue || null
    }
  }
  public mounted () {
    if (this.type === 'record') {
      this.initField()
    }
  }
  private comfirm () {
    this.form[this.item.businessId] = this.popupValue
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.changeStatus(true)
    this.popupValue = this.form[this.item.businessId] || null
  }
  private clear () {
    this.popupValue = null
  }
}
